module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAnUlEQVR4AWOgC/h/l0hEFQ0/rjPsmie4sld9Rp3CtlkCf24R0vDtKuvtI2x9HZq7V8ncP8r6+TIrAQ1vzrIXd7q2bNgYv2xFepfj+/PsWDQw+y2CI+GQ3pnlnvHT28JmVk4r9REL6USWxaKB23/K1n7rjOT0jKTUDb2WXP5TcWhAoIVGafX1OQ7lWS6GqXVALhYNb2VUiER00DAoAQDiItobq0FkywAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/EC.png
// module id = 1128
// module chunks = 0